import ImageCache from "../Shared/ImageCache";

const {ccclass, property} = cc._decorator;

@ccclass
export default class DownloadFailedImages extends cc.Component {
    start () {
        // 每过n秒，重新下载一次下载失败的图片（这样做是为了解决连续下载导致安卓闪退的bug）
        this.schedule(function () {
            ImageCache.downloadFailedImages()
        }, 6)
    } 
}